import {
    additionalField,
    apiResponse,
    timeSlots,
    events,
    units,
    locations,
    workdayCalendar,
    bookingRecord
} from "./types";
import { DateTime } from "@easepick/bundle";
import { DATE_FORMAT } from "../Constants";
import { HTTPError } from "../../../Exceptions/HTTPError";

const ROUTES = {
    base: `${Shopify.routes.root}apps/simply-book`,
    events: "/events",
    locations: "/locations",
    units: "/units",
    availableTimeSlots: "/available-time-slots",
    additionalFields: "/additionalFields",
    workdayCalendar: "/work-calendar",
    bookings: "/bookings",
    cancelBooking: "/cancel-booking",
    serviceAvailability: "/service-availability"
};

export const fetchEvents = async (category?: string): Promise<events> => {
    let url = ROUTES.events;
    if (category) {
        url += `?category=${category}`;
    }
    return (await get(url)) as events;
};

export const fetchBookings = async (): Promise<bookingRecord[]> => {
    const url = ROUTES.bookings;
    return (await get(url)) as bookingRecord[];
};

export const fetchLocations = async (event: string): Promise<locations> => {
    return (await get(`${ROUTES.locations}?event=${event}`)) as locations;
};

export const fetchUnits = async (event: string, location: string): Promise<units> => {
    let url = ROUTES.units;
    const params = [];
    if (event) {
        params.push(`event=${event}`);
    }
    if (location) {
        params.push(`location=${location}`);
    }
    if (params.length) {
        url += `?${params.join("&")}`;
    }
    return (await get(url)) as units;
};

export const fetchTimeSlots = async (from: DateTime, to: DateTime, event: string, unit: string): Promise<timeSlots> => {
    const strFrom = from.format(DATE_FORMAT.kebab);
    const strTo = to.format(DATE_FORMAT.kebab);
    const url = `${ROUTES.availableTimeSlots}?from=${strFrom}&to=${strTo}&event=${event}&unit=${unit}`;
    return (await get(url)) as timeSlots;
};

export const fetchAdditionalFields = async (event: string): Promise<additionalField[]> => {
    return (await get(`${ROUTES.additionalFields}/${event}`)) as additionalField[];
};

export const fetchServiceAvailability = async (from: DateTime, event: string, unit: string): Promise<timeSlots> => {
    const strFrom = from.format(DATE_FORMAT.kebab);
    const url = `${ROUTES.serviceAvailability}?from=${strFrom}&event=${event}&unit=${unit}`;
    return (await get(url)) as timeSlots;
};

export const fetchWorkDays = async (date: DateTime): Promise<workdayCalendar> => {
    const url = `${ROUTES.workdayCalendar}/${date.format("YYYY")}/${date.format("MM")}/${date.format("DD")}`;
    return (await get(url)) as workdayCalendar;
};

export const cancelBooking = async (id: string): Promise<boolean> => {
    const url = `${ROUTES.cancelBooking}/${id}`;
    return (await post(url)) as boolean;
};

const get = async (url: string): apiResponse => {
    const response = await fetch(ROUTES.base + url);
    if (response.status === 200) {
        return await response.json();
    } else {
        throw new HTTPError(response.status, response.statusText);
    }
};

const post = async (url: string): apiResponse => {
    const response = await fetch(ROUTES.base + url, { method: "POST" });
    if (response.status === 200) {
        return await response.json();
    } else {
        throw new HTTPError(response.status, response.statusText);
    }
};
